import { client } from '@/services/api/axios.ts';
import { useQuery } from '@tanstack/react-query';
import { format } from 'date-fns';

export type TimeSeriesPoint = {
  time: string;
  value: number;
};

export type OverviewResponse = {
  forecast?: TimeSeriesPoint;
  actualLoad?: TimeSeriesPoint;
};

interface UseGetOverviewTradingQueryParams {
  date: Date;
}

export const useGetOverviewTradingQuery = ({ date }: UseGetOverviewTradingQueryParams) => {
  const formattedDate = format(date, 'yyyy-MM-dd');

  return useQuery({
    queryKey: ['trading', 'overview', formattedDate],
    queryFn: async () => {
      const { data } = await client.get<OverviewResponse>(`/trading/overview`, {
        params: { date: formattedDate },
      });

      return data;
    },
    retry: 1,
    staleTime: 1000 * 30,
    refetchInterval: 1000 * 30,
  });
};
